module.exports = __webpack_public_path__ + "static/media/password.bfa2fd7a.svg";